export const SubAccountStatus = [
    'pending',
    'verified',
    'waiting for approval',
    'approved',
    'rejected',
];
